<template>
  <div>
    <folder-label v-if="subjects.CULTURE" label="가. NCS 소양 과목">
      <div v-for="(s, i) in subjects.CULTURE" :key="i" class="ml-3 pointer" @click="$emit('input', s)">
        <mdb-icon icon="chalkboard-teacher" /> {{s.name}}
      </div>
    </folder-label>
    <folder-label v-if="subjects.NCS" label="나. NCS 전공교과">
      <div v-for="(s, i) in subjects.NCS" :key="i" class="ml-3  pointer" @click="$emit('input', s)">
        <mdb-icon icon="chalkboard-teacher" /> {{s.name}}
      </div>
    </folder-label>
    <folder-label  v-if="subjects.NONNCS" label="다. 비 NCS 전공교과">
      <div v-for="(s, i) in subjects.NONNCS" :key="i" class="ml-3  pointer" @click="$emit('input', s)">
        <mdb-icon icon="chalkboard-teacher" /> {{s.name}}
      </div>
    </folder-label>
  </div>
</template>
<script>
import FolderLabel from '@/components/common/FolderLabel.vue';
export default {
  name: 'SubjectSelect',
  components: { FolderLabel },
  props: ['trainingId'],
  data: () => ({
    TAG: 'SubjectSelect :',
    subjects: {}
  }),
  computed: {
  },
  async created () {
    this.subjects = await this.$getSubjects(this.trainingId)
  }
}
</script>
